import { render, staticRenderFns } from "./ChooseClass.vue?vue&type=template&id=77f271c6&scoped=true"
import script from "./ChooseClass.vue?vue&type=script&lang=js"
export * from "./ChooseClass.vue?vue&type=script&lang=js"
import style0 from "./ChooseClass.vue?vue&type=style&index=0&id=77f271c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f271c6",
  null
  
)

export default component.exports